import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import './styles.scss'
import Heading from '../heading/Heading'
import Input from './../form/inputs/Input'
import InputPostal from './../form/inputs/InputPostal'
import { getApiLink } from './../../services/getApiLink'
import getDataByPostalCode from '../../services/getDataByPostalCode'
import getDataFromUrl from './../../services/getDataFromUrl';

const ProviderInfo = ( props ) => {
    const dispatch = useDispatch()

    let isShop          = useSelector(state => state.isShop);
    let providerName    = useSelector(state => state.providerName);
    let providerPostal  = useSelector(state => state.providerPostal);
    let providerNip     = useSelector(state => state.providerNip)
    let fvFile          = useSelector(state => state.fvFile)
    let fromDbLoaded    = useSelector(state => state.fromDbLoaded)
    
    useEffect(() => {
        if ( props.zip && props.zip.length > 0) 
        { 
            dispatch( {type: 'PROVIDER_POSTAL_CHANGE', value:  props.zip.toString() } )
        }
        if ( props.name && props.name.length > 0) 
        { 
            dispatch( {type: 'PROVIDER_NAME_CHANGE', value:   props.name } )
        }
        if ( props.nip && props.nip.length > 0) 
        { 
            dispatch( {type: 'PROVIDER_NIP_CHANGE', value:   props.nip } )
        }
    }, [props.zip, props.name, props.nip]);

    useEffect(() => {
        if ( providerPostal.length === 6) {
            checkPostalCode();
        }
    }, [providerPostal]);

    let checkPostalCode = async () => {
        let data = await getDataByPostalCode(providerPostal);
        let k = getDataFromUrl("k");
        if(k == "dok") {
            if ( data.status == 'done' ) {
                dispatch( {type: 'CALL_NUMBER_CHANGE', value:  '61 / 872 37 51' } )
                dispatch( {type: 'CALL_EMAIL_CHANGE', value:  data.email } ) 
            } else {
                dispatch( {type: 'CALL_NUMBER_CHANGE', value: '61 / 872 37 51' } )
                dispatch( {type: 'CALL_EMAIL_CHANGE', value: 'service@grenke.pl' } )
            }
        }else{
            if ( data.status == 'done' ) {
                dispatch( {type: 'CALL_NUMBER_CHANGE', value:  data.phone } )
                dispatch( {type: 'CALL_EMAIL_CHANGE', value:  data.email } ) 
            } else {
                dispatch( {type: 'CALL_NUMBER_CHANGE', value: '61 / 872 37 48' } )
                dispatch( {type: 'CALL_EMAIL_CHANGE', value: 'service@grenke.pl' } )
            }
        }
    }

    let fvError = async() => {
        await dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  true } )
        let elements = document.querySelectorAll('.error');
        if( elements.length > 0 ) {
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement - 140
              });

              return true;
        } else {
            return false;
        }
    }
    
    let updateInput = ( type, value) => {
        if ( fvFile.length === 0 && value.length > 0 && !fromDbLoaded) {
            fvError();
        }
        dispatch( {type: type, value: value } )
    }

    return (
        <>
        { (!isShop || (isShop && window.AppConfig && window.AppConfig.providerName.length > 0)) &&
            <div className={"provider-info " + (isShop ? 'shop' : '') }>
            <div className="wrap">
                    <Heading title="Supplier Information" 
                            borderBottom
                            tip={ false } 
                            tipHeader="Informacje o Dostawcy"
                            tipText="Wskaż pełną nazwę firmy wybranego Dostawcy oraz kod pocztowy wskazany na fakturze proforma/zamówieniu."/>

                    <div className="inputs">
                        <div className="input-col">
                            <Input 
                                id="provider-name"
                                name={"provider-name"}
                                // required={(window.AppConfig && window.AppConfig.providerName.length > 0) || !isShop ? false : true}
                                required={true}
                                setFunction={ val => {  updateInput('PROVIDER_NAME_CHANGE', val) } }
                                type="text"
                                label={ "Company name" }
                                placeholder="Company name"
                                val={ providerName } 
                                size="full" 
                                activeInput={ window.AppConfig && window.AppConfig.providerName.length > 0 ? true : false }
                                disabled={ window.AppConfig && window.AppConfig.providerName.length > 0 ? true : false }
                                regExp={ null }
                                minChar={ 1 } 
                                forceValidate={ props.forceValidate } />
                        </div>
                        {/* <div className="input-col provider-col">
                            <InputPostal 
                                id="provider-postal"
                                name={"provider-postal"}
                                required={ true }
                                setFunction={ val => { updateInput('PROVIDER_POSTAL_CHANGE', val) } }
                                type="text"
                                placehold={ "Kod pocztowy" }
                                val={ providerPostal } 
                                size="full" 
                                regExp="\d{2}-\d{3}$" 
                                allowChars={/^[0-9]{0,5}$/} 
                                activeInput={ window.AppConfig && window.AppConfig.providerPostal.length > 0 ? true : false }
                                disabled={ window.AppConfig && window.AppConfig.providerPostal.length > 0 ? true : false }

                                minChar={ 6 } 
                                forceValidate={ props.forceValidate } />
                        </div>
                        {window.AppConfig && window.AppConfig.providerName.length == 0 &&
                            <div className="input-col">
                                <Input 
                                    id="provider-nip"
                                    name={"provider-nip"}
                                    required={ true }
                                    setFunction={ val => {  updateInput('PROVIDER_NIP_CHANGE', val) } }
                                    type="text"
                                    formatAmount={ true }
                                    placehold={ "NIP" }
                                    val={ providerNip } 
                                    size="full" 
                                    activeInput={ window.AppConfig && window.AppConfig.providerName.length > 0 ? true : false }
                                    disabled={ window.AppConfig && window.AppConfig.providerName.length > 0 ? true : false }
                                    regExp={/^[0-9]{10}$/}
                                    allowChars={/^[0-9]{0,10}$/}
                                    minChar={ 1 } 
                                    disabledForce={window.AppConfig && window.AppConfig.providerName.length > 0 ? true : false}
                                    forceValidate={ props.forceValidate } />
                            </div>
                        } */}
                        
                </div>
                
                
            </div>
        </div>
        }
        </>
        
    )
}

export default ProviderInfo;